import { useEffect, useState } from 'react';
export var usePendingActions = function () {
    var _a = useState(false), showConfirmDialog = _a[0], setShowConfirmDialog = _a[1];
    var _b = useState(null), pendingAction = _b[0], setPendingAction = _b[1];
    useEffect(function () {
        if (!pendingAction) {
            setShowConfirmDialog(false);
        }
    }, [pendingAction]);
    var executeAction = function (action) {
        action();
    };
    var executeActionWithPending = function (action) {
        setPendingAction({ action: action });
        setShowConfirmDialog(true);
    };
    var onSkipSave = function () {
        if (pendingAction) {
            pendingAction.action();
        }
        setPendingAction(null);
    };
    var onCancel = function () {
        setPendingAction(null);
    };
    var resetPendingAction = function () {
        setPendingAction(null);
    };
    return {
        showConfirmDialog: showConfirmDialog,
        pendingAction: pendingAction,
        executeAction: executeAction,
        executeActionWithPending: executeActionWithPending,
        onSkipSave: onSkipSave,
        onCancel: onCancel,
        resetPendingAction: resetPendingAction,
    };
};
